export default __webpack_public_path__ + "static/media/arw-04120.f0e01fb4.jpg";